module.exports = __webpack_public_path__ + "img/icon03.2f2be3b6.png";